module.exports = __webpack_public_path__ + "statics/img/2.a078606.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/2.png
// module id = rzgL
// module chunks = 1